import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BoardError = () => /*#__PURE__*/_jsxs(ErrorMessage, {
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customer-data-board.errorBoundaries.boardTitle"
    })
  }), /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "customer-data-board.errorBoundaries.refresh_jsx",
      options: {
        onClick: () => window.location.reload(),
        use: 'link'
      },
      elements: {
        Link: Button
      }
    })
  })]
});
export default BoardError;